import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { APP_LANGUAGES, DEFAULT_LANGUAGE } from './languages';
import { localeBundles } from './locales';

const STORAGE_KEY = 'empire-maps-lang';

const resources = Object.fromEntries(
    Object.entries(localeBundles).map(([code, translation]) => [code, { translation }])
);

void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: DEFAULT_LANGUAGE,
        supportedLngs: APP_LANGUAGES.map((l) => l.code),
        nonExplicitSupportedLngs: true,
        load: 'languageOnly',
        interpolation: { escapeValue: false },
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: STORAGE_KEY,
            caches: ['localStorage'],
        },
    });

export { STORAGE_KEY };
export default i18n;
